import { BUILDER_STEP_ORDER } from 'shared/consts';

import type { BuilderStep } from '../types';

/** Narrows an arbitrary route segment to a `BuilderStep` — the single source of truth for valid step ids. */
export const isBuilderStep = (value: string): value is BuilderStep =>
  (BUILDER_STEP_ORDER as readonly string[]).includes(value);
